"use client"
import SectionPage from "@/components/common/section-page";

import {Breadcrumb, BreadcrumbItem, BreadcrumbLink, BreadcrumbList,} from "@/components/ui/breadcrumb";
import CardTitle from "@/components/common/card-title";
import AwesomeCard from "@/components/common/awesome-card";
import CiInteractiveMap, {ciInteractiveMapMarkers,} from "@/components/site-officiel/accueil/ci-interactive-map";
import { useNavigate } from "react-router-dom";

export default function Home() {
  const navigate = useNavigate();

  return (
    <div className={"flex flex-col gap-6 pb-6 bg-slate-100"}>
      <CardTitle
        title={"Nos Régions"}
        backgroundImgSrc={"/images/card-title/Nos-Regions.jpg"}
      />

      {/* Breadcrumb */}
      <SectionPage sectionType="2xl">
        <div className={"flex justify-between items-center"}>
          <Breadcrumb>
            <BreadcrumbList>
              <BreadcrumbItem>
                <BreadcrumbLink href={"/"}>Nos Régions</BreadcrumbLink>
              </BreadcrumbItem>
            </BreadcrumbList>
          </Breadcrumb>
        </div>
      </SectionPage>

      {/* Villes et Régions */}
      <SectionPage sectionType="2xl">
        <AwesomeCard
          title={"Villes et Régions"}
          className={"bg-white text-muted-foreground"}
          titleClassName={"text-bleu-marine"}
        >
          <div className={"flex justify-center w-full"}>
            <CiInteractiveMap
              strokeColor={"#ffffff"}
              markers={ciInteractiveMapMarkers(navigate)}
            />
          </div>
        </AwesomeCard>
      </SectionPage>
    </div>
  );
}
